import { type Question } from '@/types'

import { QRPairModel } from './extractQRValues'
import { getMatrixQuestionInfo } from './getMatrixQuestionInfo'
import { getMatrixRowQuestionInfo } from './getMatrixRowQuestionInfo'
import { getMatrixRowQuestionInfoByRowOrder } from './getMatrixRowQuestionInfoByRowOrder'

export const buildFunctionDescriptionByFormula = (
  questions: Question[],
  newValue: string,
  qValues: string[],
  rValues: string[],
  qrPairs: QRPairModel[]
): string => {
  const replacements = new Map<string, string>()

  rValues?.forEach((row) => {
    const { description } = getMatrixRowQuestionInfo(questions, row.slice(1))
    replacements.set(row, description)
  })

  qValues?.forEach((question) => {
    const { description } = getMatrixQuestionInfo(questions, question.slice(1))
    replacements.set(question, description)
  })

  qrPairs?.forEach((row) => {
    const { description } = getMatrixRowQuestionInfoByRowOrder(
      questions,
      Number(row.questionId),
      Number(row.rowOrder)
    )
    const qrFormat = `QR${row.questionId}_${row.rowOrder}`
    replacements.set(qrFormat, description)
  })

  let newDescription = newValue

  replacements?.forEach((value, key) => {
    newDescription = newDescription.replace(new RegExp(key, 'g'), value)
  })

  return newDescription
}
